export default "__VITE_ASSET__Db79jMTK__"